import React, {useEffect, useState} from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

export default function ActionAlerts({message, toShow}) {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        setOpen(toShow);
    }, [toShow]);
    return (
        open && <Alert onClose={() => setOpen(false)}>{message}</Alert>
    );
}